import React from 'react';
import { V2Layout, NeonDivider } from './V2Shared';
import JobRequestNew from '../JobRequestNew';
import JobRequestSuccess from '../JobRequestSuccess';
import SEO from '../components/SEO';

export function V2JobRequest() {
  return (
    <V2Layout>
      <SEO
        title="Submit a Process Serving Job — WesTex Legal"
        description="Submit your process serving job online. Upload documents, enter recipient and case details, and get a confirmed quote. Same-day rush service available across Texas and New Mexico."
        path="/job-request"
      />
      <div className="v2-jobrequest v2-jobrequest-bare" data-testid="v2-jobrequest-wrap">
        <JobRequestNew />
      </div>
    </V2Layout>
  );
}

export function V2JobRequestSuccess() {
  return (
    <V2Layout>
      <SEO
        title="Job Submitted — WesTex Legal"
        description="Your process serving job has been received. We will contact you shortly with next steps."
        path="/job-request-success"
        noindex
      />
      <div className="v2-jobrequest v2-jobrequest-bare v2-jobrequest-success" data-testid="v2-jobrequest-success-wrap">
        <JobRequestSuccess />
      </div>
      <NeonDivider delay={0.5} />
    </V2Layout>
  );
}
